const respondToMainCtaVisibility = function (element, callback) {
  const options = {
    rootMargin: '0px',
    threshold: 1,
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      callback(entry.intersectionRatio > 1 || entry.isIntersecting);
    });
  }, options);

  observer.observe(element);
};

document.addEventListener('DOMContentLoaded', () => {
  const stickyCtaContainer = document.querySelector('.sticky-cta-container');
  if (!stickyCtaContainer) return;

  const mainCtaNode = document.querySelector('.pottd-product-cta-visibility');

  // Two independent reasons to hide this bar: the page's own add-to-cart
  // button is in view, or a modal (product-modal, quick-add-modal, ...) is
  // open on top of the page. quick-add-modal in particular sits at z-index
  // 101, well under this bar's 999, so without this it stayed visible and
  // clickable over popup content — including over the popup's own quantity
  // picker and add-to-cart button.
  let mainCtaVisible = false;
  let modalOpen = false;

  const sync = () => {
    stickyCtaContainer.classList.toggle('!tw-hidden', mainCtaVisible || modalOpen);
  };

  if (mainCtaNode) {
    respondToMainCtaVisibility(mainCtaNode, (visible) => {
      mainCtaVisible = visible;
      sync();
    });
  }

  document.body.addEventListener('modalOpened', () => {
    modalOpen = true;
    sync();
  });
  document.body.addEventListener('modalClosed', () => {
    modalOpen = false;
    sync();
  });
});
